import { Slot } from '@radix-ui/react-slot'
import { useMatchRoute, useNavigate, useRouterState } from '@tanstack/react-router'

import { Link } from '@/routing/types'

export function LinkDecorator(props: Link) {
  const navigate = useNavigate()
  const matchRoute = useMatchRoute()
  const isTransitioning = useRouterState({ select: (s) => s.isTransitioning })

  if (props.external) {
    return (
      <Slot onClick={() => window.open(props.to, '_blank')} className="cursor-pointer">
        {props.children}
      </Slot>
    )
  }

  const isActive = !!matchRoute({ to: props.to, fuzzy: true })

  return (
    <Slot onClick={() => void navigate(props)} className="cursor-pointer">
      {typeof props.children === 'function' ? props.children({ isActive, isTransitioning }) : props.children}
    </Slot>
  )
}
